import { render, staticRenderFns } from "./grccms_subpage_rightcont.vue?vue&type=template&id=0a4f2512&scoped=true&"
import script from "./grccms_subpage_rightcont.vue?vue&type=script&lang=js&"
export * from "./grccms_subpage_rightcont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4f2512",
  null
  
)

export default component.exports